<template>
   <div id="page-container">
      <div class="navbar-fade-overlay"></div>

      <a href="https://gtsfly.de" target="_blank" class="logo-link">
         <inline-svg :src="logoSrc" class="logo fixed-element" width="213" height="104" />
      </a>

      <div class="header-buttons fixed-element">
         <button class="acente-btn register" id="register-btn" @click="showRegistrationForm = true">
            <div class="btn-text">
               <span class="btn-title">Noch keine Agentur?</span>
               <span class="btn-subtitle">Mach den ersten Schritt und<br />registriere dich kostenlos!</span>
            </div>
            <inline-svg :src="require('@/assets/landingpage/icons/register.svg')" width="60" height="60" />
         </button>
         <button class="acente-btn register" @click="goToLogin">
            <div class="btn-text">
               <span class="btn-title">Bereits registriert?</span>
               <span class="btn-subtitle">Jetzt einloggen!</span>
            </div>
            <inline-svg :src="require('@/assets/landingpage/icons/arrow-circle-broken-right.svg')" width="60" height="60" />
         </button>
      </div>

      <button class="jetzt-mitmachen-btn fixed-survey-btn" @click="goToSurvey">Jetzt an Umfrage teilnehmen</button>

      <div class="scroll-helper" v-if="true">
         <inline-svg :src="require('@/assets/landingpage/icons/scroll.svg')" width="64" height="72"></inline-svg>
      </div>

      <!-- Registration Form Modal -->
      <div v-if="showRegistrationForm" id="registration-form-wrapper">
         <div id="registration-form-inner-container">
            <div id="close-registration-form" @click="closeRegistrationForm">X</div>
            <div class="registration-form-overflow">
               <span class="form-title">Agentur Registrierung</span>
               <p class="form-info">Bitte füllen Sie das Formular aus, um sich als Agentur zu registrieren.</p>

               <!-- Feedback Component -->
               <div v-if="feedback.show" class="feedback-component" :class="feedback.type">
                  <div class="feedback-icon">
                     <span v-if="feedback.type === 'success'">✓</span>
                     <span v-else>✕</span>
                  </div>
                  <div class="feedback-content">
                     <p>{{ feedback.message }}</p>
                  </div>
                  <button class="feedback-close" @click="feedback.show = false">×</button>
               </div>

               <form @submit.prevent="generatePDF">
                  <div class="form-section">
                     <div class="input-container">
                        <label for="agency_name">Agenturname:</label>
                        <input id="agency_name" v-model="formData.agencyName" type="text" :disabled="isLoading" />
                     </div>

                     <div class="input-container">
                        <label for="company_manager">Geschäftsführer/ Inhaber:</label>
                        <input id="company_manager" v-model="formData.companyManager" type="text" :disabled="isLoading" />
                     </div>

                     <div class="input-container">
                        <label for="address">Anschrift:</label>
                        <input id="address" v-model="formData.address" type="text" :disabled="isLoading" />
                     </div>

                     <div class="input-container">
                        <label for="phone">Festnetz/ Mobil:</label>
                        <input id="phone" v-model="formData.phone" type="tel" :disabled="isLoading" />
                     </div>

                     <div class="input-container">
                        <label for="email">E-Mail:</label>
                        <input id="email" v-model="formData.email" type="email" :disabled="isLoading" />
                     </div>

                     <div class="input-container">
                        <label for="legal_form">Rechtsform:</label>
                        <input id="legal_form" v-model="formData.legalForm" type="text" :disabled="isLoading" />
                     </div>

                     <div class="input-container">
                        <label for="tax_number">Steuernr./ Ustld Nr.:</label>
                        <input id="tax_number" v-model="formData.taxNumber" type="text" :disabled="isLoading" />
                     </div>
                  </div>

                  <div class="consent-wrapper">
                     <span class="checkbox" @click="handlerConsentConfirmation" :class="[consentConfirmed ? 'confirmed' : '', isLoading ? 'disabled' : '']"></span>
                     <p>Ich stimme den Datenschutzbestimmungen zu.</p>
                  </div>

                  <div id="registration-form-actions">
                     <button type="submit" class="gts-primary" :disabled="!canDownloadPdf || isLoading || pdfDownloaded">
                        <span v-if="!isLoading">PDF herunterladen</span>
                        <div class="loader" v-if="isLoading"></div>
                     </button>
                  </div>
               </form>

               <div v-if="showUpload" class="upload-section">
                  <!-- File count warning -->
                  <div class="file-requirement-warning" :class="hasEnoughFiles ? 'success' : 'warning'">
                     <div class="warning-icon">
                        <span v-if="hasEnoughFiles">✓</span>
                        <span v-else>⚠</span>
                     </div>
                     <div class="warning-content">
                        <p v-if="hasEnoughFiles">Sie haben {{ uploadedFiles.length }} Datei(en) hochgeladen.</p>
                        <div v-else>
                           <ul class="form-warning-informations-wrapper">
                              <li class="form-warning-informations-item">
                                 <span class="form-warning-informations-item-title"> Schritt 1: PDF herunterladen </span>
                                 <span class="form-warning-informations-item-description"> Laden Sie das PDF-Formular herunter und drucken Sie es aus. </span>
                              </li>
                              <li class="form-warning-informations-item">
                                 <span class="form-warning-informations-item-title"> Schritt 2: Unterschreiben </span>
                                 <span class="form-warning-informations-item-description"> Unterschreiben Sie alle erforderlichen Seiten des Vertrags. </span>
                              </li>
                              <li class="form-warning-informations-item">
                                 <span class="form-warning-informations-item-title"> Schritt 3: Hochladen </span>
                                 <span class="form-warning-informations-item-description"> Scannen oder fotografieren Sie die unterschriebenen Seiten und laden Sie sie hier hoch. </span>
                              </li>
                           </ul>
                        </div>
                     </div>
                  </div>

                  <div class="upload-area" @dragover.prevent @drop="handleFileDrop">
                     <input ref="fileInput" type="file" multiple accept="image/jpeg,image/jpg,image/png,application/pdf,.pdf" @change="handleFileSelect" style="display: none" />
                     <div class="upload-content" @click="$refs.fileInput.click()">
                        <p>Dateien hier ablegen oder klicken zum Hochladen</p>
                        <div v-if="uploadedFiles.length" class="uploaded-files">
                           <div v-for="(file, index) in uploadedFiles" :key="index" class="file-item">
                              <span>{{ file.name }}</span>
                              <button @click.stop="removeFile(index)">&times;</button>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div id="registration-form-actions">
                     <button @click="submitFiles" :disabled="!uploadedFiles.length || !hasEnoughFiles || isLoading" class="gts-primary">
                        <span v-if="!isLoading">Dateien einreichen</span>
                        <div class="loader" v-if="isLoading"></div>
                     </button>
                  </div>
               </div>
            </div>
         </div>
      </div>

      <!-- First Page -->
      <section id="start" v-if="true">
         <img src="@/assets/landingpage/01.png" alt="" width="1020" class="mb-5s" id="keyvisual" />

         <div class="welcome-text">
            <h1>
               Willkommen bei gts.

               <br />
               Der Plattform für Macher.
            </h1>
            <button class="jetzt-mitmachen-btn inline-btn" @click="goToSurvey">Jetzt an Umfrage teilnehmen</button>
         </div>

         <!-- <video width="902" height="347" loop autoplay="true">
            <source src="@/assets/landingpage/01.mp4" type="video/mp4" />

            Your browser does not support the video tag.
         </video> -->
         <!--
         <div class="info-box">Diese Landinpage ist nur erreichbar über den Link via Newsletter / QR-Code / Verlinkung Banner</div>
-->
      </section>

      <!-- CONTENT ONE START -->

      <section id="page">
         <section id="content-two" v-if="true">
            <div class="mt-5 raffle-container" @click="goToSurvey">
               <inline-svg :src="require('@/assets/landingpage/icons/arrow-circle-right.svg')" width="64" height="72" />
               <p class="raffle-text">
                  <strong class="raffle-highlight">Jetzt mitmachen</strong> und die Zukunft der Buchungsplattformen <br />
                  mitgestalten - <strong class="turkish-airlines">3× Turkish Airlines</strong> zu gewinnen!
               </p>
            </div>

            <!-- SURVEY SECTION -->
            <div class="survey-container" @click="goToSurvey">
               <inline-svg :src="require('@/assets/landingpage/icons/check-circle.svg')" width="64" height="72"></inline-svg>
               <div class="survey-text">
                  <h3>Was erwartest du von einer richtig guten Plattform?</h3>
                  <p class="mt-30">
                     Deine Meinung zählt. Nimm dir kurz Zeit für unsere Umfrage und hilf uns noch besser zu werden. Als Dankeschön verlosen wir unter allen Teilnehmern 3 Turkish Airlines Tickets.
                  </p>
               </div>
            </div>
         </section>
         <section id="content-one" v-if="true">
            <div class="content-wrapper">
               <div class="text-content">
                  <h1>Alles, was Reisebüros brauchen.</h1>
                  <h2 class="mt-2">
                     Eine Plattform.
                     <br />
                     Unzählige Möglichkeiten.
                  </h2>

                  <p class="mt-5">
                     <strong> gts (Global Travel Services)</strong> ist die leistungsstarke Online-Reisebuchungsplattform aus Deutschland – entwickelt
                     <strong>für Reiseprofis, die mehr wollen.</strong>
                  </p>
                  <p class="mt-3">Ob Pauschalreise, Hotel, Flug oder Zusatzleistung: <strong>gts bündelt sämtliche Reiseprodukte an einem Ort</strong> und macht sie sofort vergleichbar.</p>
                  <p class="mt-3">
                     Statt zwischen verschiedenen Systemen zu wechseln, <strong>vergleichen Reisebüros Angebote mehrerer Anbieter in Echtzeit–</strong> transparent, effizient und flexibel. So
                     entstehen individuelle Reiseerlebnisse, exakt zugeschnitten auf die Wünsche Ihrer Kundinnen und Kunden.
                  </p>

                  <p class="mt-4">
                     <strong> Auf Wunsch natürlich mit Sicherungsschein! </strong>
                  </p>
               </div>

               <ul class="feature-boxes">
                  <li>
                     <inline-svg :src="require('@/assets/landingpage/icons/check-circle.svg')" width="64" height="72"></inline-svg>
                     alle relevanten Reiseprodukte auf einer zentralen Plattform
                  </li>
                  <li>
                     <inline-svg :src="require('@/assets/landingpage/icons/check-circle.svg')" width="64" height="72"></inline-svg>
                     direkter Angebotsvergleich mehrerer Veranstalter
                  </li>
                  <li>
                     <inline-svg :src="require('@/assets/landingpage/icons/check-circle.svg')" width="64" height="72"></inline-svg>
                     maximale Flexibilität + Sicherungsschein bei der Zusammenstellung individueller Reisen
                  </li>
                  <li>
                     <inline-svg :src="require('@/assets/landingpage/icons/check-circle.svg')" width="64" height="72"></inline-svg>
                     mehr Effizienz im Beratungs- und Buchungsprozess
                  </li>
               </ul>
            </div>
         </section>
         <!-- CONTENT TWO START -->

         <!-- CONTENT SLİDER -->
         <section id="slider" v-if="true">
            <div class="slider-content">
               <div class="slide">
                  <transition name="fade" mode="out-in">
                     <div class="slide-up-section" :key="currentSlide + '-up'">
                        <span class="title" v-html="slides[currentSlide].title.replace(/\n/g, '<br />')"></span>
                        <inline-svg :src="require(`@/assets/landingpage/icons/${slides[currentSlide].icon}.svg`)" :width="slides[currentSlide].iconWidth" :height="slides[currentSlide].iconHeight" />
                     </div>
                  </transition>

                  <span class="sub-title" :key="currentSlide + '-sub'" v-html="slides[currentSlide].subTitle.replace(/\n/g, '<br />')"></span>
               </div>

               <div class="slider-bullets">
                  <button v-for="(slide, index) in slides" :key="index" :class="{ active: index === currentSlide }" @click="goToSlide(index)" class="bullet">{{ index + 1 }}</button>
               </div>
            </div>
         </section>

         <!-- CONTACT SECTION -->
         <section id="contact-section" class="mt-5" v-if="true">
            <h2 class="main-title mt-3">gts ist mehr als ein Buchungssystem.</h2>
            <h3 class="main-subtitle">
               Es ist die Plattform für Macherinnen und Macher im Reisevertrieb <br />
               schnell, professionell und zukunftsorientiert.
            </h3>

            <h2 class="contact-title">Persönlich mehr erfahren?</h2>
            <p class="contact-subtitle">Ich bin für Sie da. Anruf oder Mail genügen.</p>

            <div class="contact-card">
               <div class="contact-image">
                  <img src="@/assets/landingpage/sinan_kasap.png" alt="Sinan Kasap" />
               </div>
               <div class="contact-info">
                  <h3>Sinan Kasap</h3>
                  <a href="mailto:sinan.kasap@gtsfly.de" class="contact-email">sinan.kasap@gtsfly.de</a>
                  <a href="tel:+4915224318268" class="contact-phone">+49 152 243 18 268</a>
               </div>
            </div>
         </section>
      </section>
   </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import InlineSvg from "vue-inline-svg";
import { PDFDocument } from "pdf-lib";
import { applicationPDFForm } from "@/service/rest.api";

gsap.registerPlugin(ScrollTrigger);

export default {
   name: "MachDochEinfachPage",
   components: {
      InlineSvg,
   },
   computed: {
      logoSrc() {
         return require("@/assets/landingpage/icons/logo-on-dark.svg");
      },
      canDownloadPdf() {
         const namePattern = /^[a-zA-ZäöüÄÖÜßçğıİöşüÇĞŞ\s]+$/;
         const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
         const phonePattern = /^\+?[\d\s-()]+$/;

         return (
            this.formData.agencyName.trim() !== "" &&
            this.formData.companyManager.trim() !== "" &&
            namePattern.test(this.formData.companyManager.trim()) &&
            this.formData.address.trim() !== "" &&
            this.formData.phone.trim() !== "" &&
            phonePattern.test(this.formData.phone.trim()) &&
            this.formData.email.trim() !== "" &&
            emailPattern.test(this.formData.email.trim()) &&
            this.formData.legalForm.trim() !== "" &&
            this.formData.taxNumber.trim() !== "" &&
            this.consentConfirmed
         );
      },
      hasEnoughFiles() {
         return this.uploadedFiles.length >= 1;
      },
   },
   data() {
      return {
         showRegistrationForm: false,
         formData: {
            agencyName: "",
            companyManager: "",
            address: "",
            phone: "",
            email: "",
            legalForm: "",
            taxNumber: "",
         },
         showUpload: false,
         uploadedFiles: [],
         consentConfirmed: false,
         isLoading: false,
         pdfDownloaded: false,
         feedback: {
            show: false,
            type: "success",
            message: "",
         },
         isLightSection: false,
         currentSlide: 0,
         slides: [
            {
               title: "Selber paketieren?",
               icon: "slide-01",
               iconWidth: 128,
               iconHeight: 101,
               subTitle: "Kostenloser Sicherungsschein inklusive: attraktive\nFlugraten, das Traumhotel und der passende Transfer.\nSo geht maßgeschneidert verkaufen!",
            },
            {
               title: "Support,\nder wirklich hilft?",
               icon: "slide-02",
               iconWidth: 112,
               iconHeight: 108,
               subTitle: "Deutschsprachiger Support in unter 2 Minuten.\nPer Chat, Mail oder Telefon. Wir sind für dich da!",
            },
            {
               title: "Deine Liquidität\noptimieren?",
               icon: "slide-03",
               iconWidth: 97,
               iconHeight: 97,
               subTitle: "Auszahlung deiner Provision bei Buchung.\nDein Cashflow bleibt im grünen Bereich.",
            },
            {
               title: "Selber deinen\nErtrag bestimmen?",
               icon: "slide-04",
               iconWidth: 97,
               iconHeight: 97,
               subTitle: "Mit gts bestimmst du deinen Ertrag und verdienst,\nwas du verdienst.",
            },
            {
               title: "Schneller buchen &\nmehr verdienen?",
               icon: "slide-05",
               iconWidth: 122,
               iconHeight: 89,
               subTitle: "Buchung in 3 Klicks statt 30 Minuten.\nMehr Zeit für Beratung und Umsatz pro Kunde.",
            },
            {
               title: "Beste Flugpreise\nsichern?",
               icon: "slide-06",
               iconWidth: 129,
               iconHeight: 97,
               subTitle: "Direktanbindung von mehr als 450 Airlines.\nImmer die aktuellsten Raten, immer die beste Marge.",
            },
            {
               title: "Stressfrei umbuchen?",
               icon: "slide-07",
               iconWidth: 86,
               iconHeight: 99,
               subTitle: "Stornos und Umbuchungen in Echtzeit.\nKeine Hotline-Warteschleifen, keine versteckten Gebühren.",
            },
            {
               title: "Einfach als\nUnternehmer handeln?",
               icon: "slide-08",
               iconWidth: 88,
               iconHeight: 106,
               subTitle: "Keine Vorgaben, keine Mindestabnahmen.\nDu entscheidest, was, wie und zu welchem Preis du verkaufst.",
            },
            {
               title: "Mit deiner Expertise\nReisen frei gestalten?",
               icon: "slide-09",
               iconWidth: 70,
               iconHeight: 104,
               subTitle: "So einfach geht Maßarbeit. Zeig was du kannst,\nbuche ganz einfach die optimalen Bausteine und \nmache deine Kunden glücklich.",
            },
         ],
      };
   },
   mounted() {
      // Fixed survey button visibility based on scroll
      this.setupFixedSurveyButton();

      // Reveal animations for #page sections
      this.setupPageRevealAnimations();

      // Mouse-reactive gradient mesh for #start
      // this.setupMouseGradient();
      this.setupAutoGradientAnimation();

      // Keyvisual animations
      this.setupKeyvisualAnimations();

      // Info box scroll animation
      this.setupInfoBoxScroll();

      this.startSlider();
   },
   methods: {
      startSlider() {
         this.sliderInterval = setInterval(() => {
            this.currentSlide = (this.currentSlide + 1) % this.slides.length;
         }, 2000);
      },
      goToSlide(index) {
         this.currentSlide = index;
         // Reset interval when user manually clicks a bullet
         if (this.sliderInterval) {
            clearInterval(this.sliderInterval);
            this.startSlider();
         }
      },
      // setupMouseGradient() {
      //    const pageContainer = document.querySelector("#page-container");
      //    if (!pageContainer) return;

      //    const gradientPos = { x: 50, y: 50 };

      //    this.handleMouseMove = (e) => {
      //       const x = (e.clientX / window.innerWidth) * 100;
      //       const y = (e.clientY / window.innerHeight) * 100;

      //       gsap.to(gradientPos, {
      //          x,
      //          y,
      //          duration: 1.5,
      //          ease: "power2.out",
      //          onUpdate: () => {
      //             pageContainer.style.setProperty("--grad-x1", `${gradientPos.x}%`);
      //             pageContainer.style.setProperty("--grad-y1", `${gradientPos.y}%`);
      //             pageContainer.style.setProperty("--grad-x2", `${100 - gradientPos.x}%`);
      //             pageContainer.style.setProperty("--grad-y2", `${gradientPos.y}%`);
      //             pageContainer.style.setProperty("--grad-x3", `${gradientPos.x}%`);
      //             pageContainer.style.setProperty("--grad-y3", `${100 - gradientPos.y}%`);
      //             pageContainer.style.setProperty("--grad-x4", `${100 - gradientPos.x}%`);
      //             pageContainer.style.setProperty("--grad-y4", `${100 - gradientPos.y}%`);
      //          },
      //       });
      //    };

      //    pageContainer.addEventListener("mousemove", this.handleMouseMove);
      // },
      setupAutoGradientAnimation() {
         const pageContainer = document.querySelector("#page-container");
         if (!pageContainer) return;

         const gradientPos = {
            x1: 30,
            y1: 40,
            x2: 70,
            y2: 40,
            x3: 30,
            y3: 60,
            x4: 70,
            y4: 60,
         };

         // Smooth, slow, continuous animation
         gsap.to(gradientPos, {
            x1: 70,
            y1: 60,
            x2: 30,
            y2: 60,
            x3: 70,
            y3: 40,
            x4: 30,
            y4: 40,
            duration: 10,
            ease: "sine.inOut",
            repeat: -1,
            yoyo: true,
            onUpdate: () => {
               pageContainer.style.setProperty("--grad-x1", `${gradientPos.x1}%`);
               pageContainer.style.setProperty("--grad-y1", `${gradientPos.y1}%`);
               pageContainer.style.setProperty("--grad-x2", `${gradientPos.x2}%`);
               pageContainer.style.setProperty("--grad-y2", `${gradientPos.y2}%`);
               pageContainer.style.setProperty("--grad-x3", `${gradientPos.x3}%`);
               pageContainer.style.setProperty("--grad-y3", `${gradientPos.y3}%`);
               pageContainer.style.setProperty("--grad-x4", `${gradientPos.x4}%`);
               pageContainer.style.setProperty("--grad-y4", `${gradientPos.y4}%`);
            },
         });
      },
      setupKeyvisualAnimations() {
         const keyvisual = document.querySelector("#keyvisual");
         if (!keyvisual) return;

         // Random blink animation
         const randomBlink = () => {
            gsap.to(keyvisual, {
               opacity: 0.3,
               duration: 0.1,
               ease: "power2.inOut",
               onComplete: () => {
                  gsap.to(keyvisual, {
                     opacity: 1,
                     duration: 0.1,
                     ease: "power2.inOut",
                     onComplete: () => {
                        const delay = gsap.utils.random(3, 8);
                        gsap.delayedCall(delay, randomBlink);
                     },
                  });
               },
            });
         };
         gsap.delayedCall(gsap.utils.random(2, 5), randomBlink);

         // Mouse parallax effect (opposite direction)
         const startSection = document.querySelector("#start");
         if (!startSection) return;

         this.handleKeyvisualMove = (e) => {
            const rect = startSection.getBoundingClientRect();
            const x = ((e.clientX - rect.left) / rect.width - 0.5) * -20; // -20 = subtle movement in opposite direction
            const y = ((e.clientY - rect.top) / rect.height - 0.5) * -20;

            gsap.to(keyvisual, {
               x,
               y,
               duration: 1.5,
               ease: "power2.out",
            });
         };

         startSection.addEventListener("mousemove", this.handleKeyvisualMove);
      },
      setupInfoBoxScroll() {
         const infoBox = document.querySelector(".info-box");
         const pageContainer = document.querySelector("#page-container");
         if (!infoBox || !pageContainer) return;

         pageContainer.addEventListener("scroll", () => {
            const scrollY = pageContainer.scrollTop;
            const translateX = Math.min(scrollY * 0.5, 400);
            const opacity = Math.max(1 - scrollY / 300, 0);

            infoBox.style.transform = `translateX(${translateX}px)`;
            infoBox.style.opacity = opacity;
         });
      },
      async generatePDF() {
         this.isLoading = true;
         this.feedback.show = false;

         try {
            const query = {
               "agency-name": this.formData.agencyName,
               "company-officer": this.formData.companyManager,
               "company-address": this.formData.address,
               "company-phone": this.formData.phone,
               "company-email": this.formData.email,
               "legal-form": this.formData.legalForm,
               "tax-number": this.formData.taxNumber,
            };

            const formData = new FormData();
            for (const field in query) {
               formData.append(field, query[field]);
            }

            await applicationPDFForm(formData);

            const response = await fetch("/agenturvertrag.pdf");
            if (!response.ok) {
               throw new Error(`PDF yüklenemedi: ${response.status}`);
            }

            const pdfBytes = await response.arrayBuffer();
            const pdfDoc = await PDFDocument.load(pdfBytes);
            const form = pdfDoc.getForm();

            const fieldMapping = {
               text_1hywu: this.formData.agencyName,
               text_2irya: this.formData.companyManager,
               text_3kmhv: this.formData.address,
               text_4fnnt: this.formData.phone,
               text_5gjim: this.formData.email,
               text_6rcid: this.formData.legalForm,
               text_7zsmp: this.formData.taxNumber,
            };

            for (const [fieldName, value] of Object.entries(fieldMapping)) {
               try {
                  const field = form.getTextField(fieldName);
                  if (field && value) {
                     const cleanValue = this.sanitizeForPDF(value.toString());
                     field.setText(cleanValue);
                  }
               } catch (error) {
                  console.warn(`Field ${fieldName} bulunamadı:`, error);
               }
            }

            const filledPdfBytes = await pdfDoc.save();
            const blob = new Blob([filledPdfBytes], { type: "application/pdf" });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "agenturvertrag.pdf";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            this.pdfDownloaded = true;
            this.showFeedback("success", "PDF wurde erfolgreich heruntergeladen!", false);
            this.showUpload = true;
         } catch (error) {
            console.error("PDF işleme hatası:", error);
            this.showFeedback("error", "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
         } finally {
            this.isLoading = false;
         }
      },
      handleFileSelect(event) {
         const files = Array.from(event.target.files);
         this.addFiles(files);
      },
      handleFileDrop(event) {
         event.preventDefault();
         const files = Array.from(event.dataTransfer.files);
         this.addFiles(files);
      },
      addFiles(files) {
         const validFiles = files.filter((file) => file.type === "image/jpeg" || file.type === "image/jpg" || file.type === "image/png" || file.type === "application/pdf");
         this.uploadedFiles.push(...validFiles);
      },
      removeFile(index) {
         this.uploadedFiles.splice(index, 1);
      },
      async submitFiles() {
         if (!this.uploadedFiles.length) return;

         if (!this.hasEnoughFiles) {
            this.showFeedback("error", "Bitte laden Sie mindestens eine Datei hoch.");
            return;
         }

         const query = {
            "agency-name": this.formData.agencyName,
            "company-officer": this.formData.companyManager,
            "company-address": this.formData.address,
            "company-phone": this.formData.phone,
            "company-email": this.formData.email,
            "legal-form": this.formData.legalForm,
            "tax-number": this.formData.taxNumber,
         };

         const formData = new FormData();
         for (const field in query) {
            formData.append(field, query[field]);
         }

         this.uploadedFiles.forEach((file) => {
            formData.append("contracting[]", file);
         });

         this.isLoading = true;
         this.feedback.show = false;
         try {
            const res = await applicationPDFForm(formData);
            if (res && res.status == "mail_sent") {
               this.showFeedback("success", "Dateien wurden erfolgreich eingereicht!");
               this.uploadedFiles = [];
               this.showUpload = false;
               this.resetForm();
               this.showRegistrationForm = false;
            } else if (res instanceof Blob) {
               this.showFeedback("success", "Dateien wurden erfolgreich eingereicht!");
               this.uploadedFiles = [];
               this.showUpload = false;
               this.resetForm();
               this.showRegistrationForm = false;
            } else {
               this.showFeedback("error", "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
            }
         } catch (error) {
            console.error("Upload error:", error);
            this.showFeedback("error", "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
         } finally {
            this.isLoading = false;
         }
      },
      resetForm() {
         Object.keys(this.formData).forEach((key) => {
            this.formData[key] = "";
         });
         this.consentConfirmed = false;
         this.pdfDownloaded = false;
      },
      closeRegistrationForm() {
         this.showRegistrationForm = false;
         this.resetForm();
         this.showUpload = false;
         this.uploadedFiles = [];
         this.feedback.show = false;
      },
      handlerConsentConfirmation() {
         if (!this.isLoading) {
            this.consentConfirmed = !this.consentConfirmed;
         }
      },
      showFeedback(type, message, autoHide = true) {
         this.feedback = {
            show: true,
            type: type,
            message: message,
         };

         if (autoHide) {
            setTimeout(() => {
               this.feedback.show = false;
            }, 5000);
         }
      },
      sanitizeForPDF(text) {
         const charMap = {
            ı: "i",
            İ: "I",
            ğ: "g",
            Ğ: "G",
            ü: "u",
            Ü: "U",
            ş: "s",
            Ş: "S",
            ö: "o",
            Ö: "O",
            ç: "c",
            Ç: "C",
            â: "a",
            Â: "A",
            î: "i",
            Î: "I",
            û: "u",
            Û: "U",
            ê: "e",
            Ê: "E",
         };

         return text.replace(/[ıİğĞüÜşŞöÖçÇâÂîÎûÛêÊ]/g, (match) => charMap[match] || match);
      },
      goToLogin() {
         window.open("https://agent.gtsfly.de", "_blank");
      },
      goToSurvey() {
         window.open("https://forms.gle/JgTgs4gm1yitDdWKA", "_blank");
      },
      setupPageRevealAnimations() {
         // Content-two reveal animation
         gsap.from("#content-two > *", {
            opacity: 0,
            y: 50,
            duration: 1,
            stagger: 0.2,
            ease: "power2.out",
            scrollTrigger: {
               trigger: "#content-two",
               scroller: "#page-container",
               start: "top 80%",
               end: "bottom top",
               toggleActions: "play none none reverse",
            },
         });

         // Content-one text reveal animation
         gsap.from("#content-one .text-content > *", {
            opacity: 0,
            y: 50,
            duration: 1,
            stagger: 0.2,
            ease: "power2.out",
            scrollTrigger: {
               trigger: "#content-one",
               scroller: "#page-container",
               start: "top 80%",
               end: "bottom top",
               toggleActions: "play none none reverse",
            },
         });

         // Feature boxes reveal animation
         gsap.from("#content-one .feature-boxes li", {
            opacity: 0,
            y: 50,
            duration: 0.8,
            stagger: 0.15,
            ease: "power2.out",
            scrollTrigger: {
               trigger: "#content-one .feature-boxes",
               scroller: "#page-container",
               start: "top 80%",
               end: "bottom top",
               toggleActions: "play none none reverse",
            },
         });

         // Slider reveal animation
         gsap.from("#slider .slider-content", {
            opacity: 0,
            y: 50,
            duration: 1,
            ease: "power2.out",
            scrollTrigger: {
               trigger: "#slider",
               scroller: "#page-container",
               start: "top 80%",
               end: "bottom top",
               toggleActions: "play none none reverse",
            },
         });

         // Contact section reveal animation
         gsap.from("#contact-section > *", {
            opacity: 0,
            y: 50,
            duration: 1,
            stagger: 0.15,
            ease: "power2.out",
            scrollTrigger: {
               trigger: "#contact-section",
               scroller: "#page-container",
               start: "top 80%",
               end: "bottom top",
               toggleActions: "play none none reverse",
            },
         });
      },
      setupFixedSurveyButton() {
         const pageContainer = document.querySelector("#page-container");
         const fixedSurveyBtn = document.querySelector(".fixed-survey-btn");
         const startSection = document.querySelector("#start");
         const scrollHelper = document.querySelector(".scroll-helper");

         if (!pageContainer || !fixedSurveyBtn || !startSection) return;

         pageContainer.addEventListener("scroll", () => {
            const startSectionBottom = startSection.offsetTop + startSection.offsetHeight;
            const scrollY = pageContainer.scrollTop;

            if (scrollY > startSectionBottom) {
               fixedSurveyBtn.classList.add("show");
            } else {
               fixedSurveyBtn.classList.remove("show");
            }

            // Hide scroll helper on any scroll
            if (scrollHelper && scrollY > 0) {
               gsap.to(scrollHelper, {
                  opacity: 0,
                  duration: 0.3,
                  ease: "power2.out",
               });
            } else if (scrollHelper && scrollY === 0) {
               gsap.to(scrollHelper, {
                  opacity: 1,
                  duration: 0.3,
                  ease: "power2.out",
               });
            }
         });
      },
   },
   beforeUnmount() {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());

      if (this.sliderInterval) {
         clearInterval(this.sliderInterval);
      }

      const pageContainer = document.querySelector("#page-container");
      if (pageContainer && this.handleMouseMove) {
         pageContainer.removeEventListener("mousemove", this.handleMouseMove);
      }

      const startSection = document.querySelector("#start");
      if (startSection && this.handleKeyvisualMove) {
         startSection.removeEventListener("mousemove", this.handleKeyvisualMove);
      }
   },
};
</script>

<style lang="scss">
// $section-dark: #0f0f1a;
$section-dark: #11111b;

$section-light: #fff;

#page-container {
   font-family: "Poppins", sans-serif;
   height: 100vh;
   overflow-y: scroll;
   scroll-behavior: smooth;
   position: relative;
   background-color: $section-dark;
   scroll-snap-type: y mandatory;
   --grad-x1: 50%;
   --grad-y1: 50%;
   --grad-x2: 50%;
   --grad-y2: 50%;
   --grad-x3: 50%;
   --grad-y3: 50%;
   --grad-x4: 50%;
   --grad-y4: 50%;

   &::before {
      content: "";
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: radial-gradient(circle at var(--grad-x1) var(--grad-y1), rgba(26, 26, 46, 0.2) 0%, transparent 50%),
         radial-gradient(circle at var(--grad-x2) var(--grad-y2), rgba(22, 33, 62, 0.2) 0%, transparent 40%),
         radial-gradient(circle at var(--grad-x3) var(--grad-y3), rgba(77, 15, 96, 0.2) 0%, transparent 40%),
         radial-gradient(circle at var(--grad-x4) var(--grad-y4), rgba(4, 167, 231, 0.2) 0%, transparent 50%);
      z-index: 0;
      pointer-events: none;
   }

   &::after {
      content: "";
      position: fixed;
      top: -50%;
      left: -50%;
      right: -50%;
      bottom: -50%;
      width: 200%;
      height: 200%;
      background: transparent url("http://assets.iceable.com/img/noise-transparent.png") repeat 0 0;
      opacity: 0.4;
      z-index: 1;
      pointer-events: none;
      animation: noise-animation 0.2s infinite;
   }

   *,
   *::before,
   *::after {
      font-family: "Poppins", sans-serif;
   }

   ::selection {
      background-color: #d72eda;
      color: #0f0f1a;
   }

   ::-moz-selection {
      background-color: #d72eda;
      color: #0f0f1a;
   }

   .fixed-element {
      position: fixed;
      z-index: 100;
      transition: all 0.15s ease;
   }

   // Fade out overlay for top navbar area
   .navbar-fade-overlay {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      height: 230px;
      background: linear-gradient(to bottom, $section-dark 0%, $section-dark 40%, transparent 100%);
      pointer-events: none;
      z-index: 99;

      @media (max-width: 768px) {
         height: 150px;
         background-color: #00000090;
      }
   }

   .logo-link {
      position: fixed;
      z-index: 100;
      top: 2rem;
      left: 2rem;

      @media (max-width: 768px) {
         position: fixed;
         top: 0.5rem;
         left: 0.5rem;
         right: 0;
         margin: 0 auto;
         // width: 213px;
         transform: scale(0.8);
         transform-origin: left;

         .logo {
            left: 0;
         }
      }
   }

   .logo {
      top: 2rem;
      left: 2rem;
   }

   .header-buttons {
      top: 2rem;
      right: 2rem;
      display: flex;
      gap: 1rem;

      @media (max-width: 1024px) and (min-width: 769px) {
         gap: 0.75rem;
         top: 1.5rem;
         right: 1.5rem;
      }

      @media (max-width: 768px) {
         flex-direction: column;
         gap: 0.5rem;
         top: 2rem;
         right: 1rem;
      }
   }

   .fixed-survey-btn {
      position: fixed;
      bottom: 2rem;
      right: 2rem;
      z-index: 100;
      width: 100px;
      height: 100px;
      border-radius: 100%;
      background-color: transparent;
      color: #ffdff3;
      cursor: pointer;
      box-shadow: 0 0 20px rgba(4, 178, 231, 0.5), 0 0 40px rgba(4, 178, 231, 0.3);
      transition: all 0.3s ease;
      border: 2px solid transparent;
      background-image: linear-gradient(#1d1d39, #1a101b), linear-gradient(135deg, #10ade4, #7500cd);
      background-origin: border-box;
      background-clip: padding-box, border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 4rem;
      font-size: 15px;
      font-weight: 400;
      opacity: 0;
      pointer-events: none;

      @media (max-width: 768px) {
         font-size: 0.8rem;
         padding: 0.6rem 1.5rem;
         bottom: 1.5rem;
         right: 1.5rem;
         //  display: none;
      }

      &:hover {
         background-image: linear-gradient(#fff, #fff), linear-gradient(135deg, #10ade4, #7500cd);
         color: #0f0f1a;
         box-shadow: 0 0 30px rgba(4, 178, 231, 0.8), 0 0 60px rgba(4, 178, 231, 0.5);
         transform: translateY(-2px);
      }
   }

   .fixed-survey-btn.show {
      opacity: 1;
      pointer-events: auto;
   }

   .acente-btn {
      background-color: transparent;
      color: #fff;
      padding: 0.75rem 2rem;
      border-radius: 24px;
      font-size: 1rem;
      font-weight: 500;
      cursor: pointer;
      box-shadow: 0 0 20px rgba(4, 178, 231, 0.5), 0 0 40px rgba(4, 178, 231, 0.3);
      transition: all 0.3s ease;
      position: relative;
      border: 2px solid transparent;
      background-image: linear-gradient(#1d1d39, #1a101b), linear-gradient(135deg, #10ade4, #7500cd);
      background-origin: border-box;
      background-clip: padding-box, border-box;
      display: flex;
      align-items: center;
      gap: 0.75rem;

      @media (max-width: 1024px) and (min-width: 769px) {
         padding: 0.6rem 1.5rem;
         font-size: 0.9rem;
         gap: 0.5rem;

         svg {
            width: 48px !important;
            height: 48px !important;
         }
      }

      @media (max-width: 768px) {
         padding: 0.5rem 0.75rem;
         font-size: 0.75rem;
         border-radius: 16px;
         gap: 0.25rem;
         box-shadow: 0 0 10px rgba(4, 178, 231, 0.4), 0 0 20px rgba(4, 178, 231, 0.2);

         svg {
            width: 24px !important;
            height: 24px !important;
         }
      }

      &.register {
         padding-right: 1rem;

         @media (max-width: 1024px) and (min-width: 769px) {
            padding-right: 0.75rem;
         }

         @media (max-width: 768px) {
            padding-right: 0.5rem;
         }
      }

      .btn-text {
         display: flex;
         flex-direction: column;
         align-items: flex-start;
         gap: 0.25rem;
      }

      .btn-title {
         font-size: 16px;
         font-weight: 600;
         line-height: 1.2;

         @media (max-width: 1024px) and (min-width: 769px) {
            font-size: 14px;
         }

         @media (max-width: 768px) {
            font-size: 11px;
         }
      }

      .btn-subtitle {
         font-size: 14px;
         font-weight: 400;
         line-height: 1.2;
         opacity: 0.9;
         text-align: left;

         @media (max-width: 1024px) and (min-width: 769px) {
            font-size: 12px;
         }

         @media (max-width: 768px) {
            display: none;
         }
      }

      &:hover {
         background-image: linear-gradient(#fff, #fff), linear-gradient(135deg, #10ade4, #7500cd);
         color: #0f0f1a;
         box-shadow: 0 0 30px rgba(4, 178, 231, 0.8), 0 0 60px rgba(4, 178, 231, 0.5);

         svg {
            filter: brightness(0);
         }
      }
   }

   #page {
      position: relative;
      z-index: 2;
      scroll-snap-align: start;
      padding-top: 3rem;
   }

   #content-two,
   #content-one,
   #slider,
   #contact-section {
      padding: 0rem 6rem;
      padding-bottom: 10rem;
      display: flex;
      flex-direction: column;

      @media (max-width: 768px) {
         padding: 4rem 2rem;
      }
   }

   #contact-section {
      padding-top: 2rem;
   }
   #content-two {
      padding-bottom: 5rem;
   }
   #content-one {
      padding-bottom: 5rem;
   }

   section {
      // min-height: auto;
      // width: 100%;
      // display: flex;
      // flex-direction: column;
      // padding: 0rem 6rem;
      // padding-top: 6rem;
      // padding-bottom: 6rem;
      // position: relative;
      // z-index: 2;

      &#start {
         padding: 0rem 6rem;
         display: flex;
         flex-direction: column;
         min-height: 100vh;
         justify-content: flex-start;
         align-items: center;
         position: relative;
         padding-top: 10rem;
         scroll-snap-align: start;
         @media (max-height: 790px) {
            padding-top: 4rem;
         }

         .welcome-text {
            text-align: center;
            margin-top: -120px;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 2rem;

            @media (max-width: 768px) {
               margin-top: 0;
            }

            h1 {
               font-size: 36px;
               font-weight: 400;
               color: #fff;
               margin: 0;
               line-height: 1.5;

               @media (max-width: 768px) {
                  font-size: 28px;
               }
            }

            .jetzt-mitmachen-btn {
               background-color: transparent;
               color: #fff;
               padding: 1rem 2.5rem;
               border-radius: 24px;
               font-size: 1.1rem;
               font-weight: 600;
               cursor: pointer;
               box-shadow: 0 0 20px rgba(4, 178, 231, 0.5), 0 0 40px rgba(4, 178, 231, 0.3);
               transition: all 0.3s ease;
               border: 2px solid transparent;
               background-image: linear-gradient(#1d1d39, #1a101b), linear-gradient(135deg, #10ade4, #7500cd);
               background-origin: border-box;
               background-clip: padding-box, border-box;

               @media (max-width: 768px) {
                  font-size: 1rem;
                  padding: 0.75rem 2rem;
               }

               &:hover {
                  background-image: linear-gradient(#fff, #fff), linear-gradient(135deg, #10ade4, #7500cd);
                  color: #0f0f1a;
                  box-shadow: 0 0 30px rgba(4, 178, 231, 0.8), 0 0 60px rgba(4, 178, 231, 0.5);
                  transform: translateY(-2px);
               }
            }
         }

         #keyvisual {
            margin-top: 2rem;

            @media (max-width: 768px) {
               width: 100%;
            }
         }

         .info-box {
            position: fixed;
            bottom: 0.5rem;
            right: 0.5rem;
            background-color: rgba(0, 0, 0, 0.3);
            color: #fff;
            padding: 0.6rem 1rem;
            border-radius: 8px;
            font-size: 14px;
            max-width: 300px;
            line-height: 1.6;
            z-index: 10;
            color: #a6a6a6;
            transition: transform 0.3s ease, opacity 0.3s ease;
            // color: #d72eda;
         }

         & > * {
            position: relative;
            z-index: 2;
         }
      }

      &#content-one {
         background-color: transparent;
         padding-top: 2rem;

         .content-wrapper {
            display: flex;
            flex-direction: row;
            gap: 1.5rem;
            width: 100%;
            align-items: flex-start;

            @media (max-width: 768px) {
               flex-direction: column;
            }

            .text-content {
               flex: 1;
            }

            .feature-boxes {
               display: grid;
               grid-template-columns: repeat(2, 1fr);
               gap: 2.5rem;
               flex: 0 0 auto;
               width: 730px;
               margin-right: 7rem;
               margin-top: 7rem;

               @media (max-width: 1400px) {
                  width: 600px;
                  margin-right: 3rem;
                  margin-top: 3rem;
                  gap: 2rem;
               }

               @media (max-width: 1024px) {
                  width: 100%;
                  margin-right: 0;
                  margin-top: 3rem;
                  grid-template-columns: repeat(2, 1fr);
               }

               @media (max-width: 768px) {
                  grid-template-columns: 1fr;
                  gap: 1.5rem;
                  margin-top: 2rem;
               }
            }
         }
      }
      &#content-two {
         padding-top: 8rem;
         background-color: transparent;

         h1,
         h3,
         p {
            color: #fff !important;
         }

         h2 {
            color: #fb3cd4 !important;
         }

         .survey-container {
            display: flex;
            align-items: center;
            gap: 2rem;
            background-color: #0000004a;
            padding: 2rem;
            border-radius: 1rem;
            margin-top: 4rem;
            width: fit-content;
            cursor: pointer;
            border: 2px solid rgba(215, 46, 218, 0.3);

            @media (max-width: 768px) {
               flex-direction: column;
               width: 100%;
               padding: 1.5rem 1rem;
               text-align: center;
               margin-top: 2rem;
            }

            &:hover {
               border-color: #d72eda;
               background: #11111b;
            }

            svg {
               flex-shrink: 0;
            }

            .survey-text {
               flex: 1;

               h3 {
                  color: #fff;
                  margin: 0;

                  @media (max-width: 768px) {
                     font-size: 20px;
                  }
               }

               p {
                  color: #fff;
                  margin: 0;

                  @media (max-width: 768px) {
                     font-size: 14px;
                     line-height: 1.6;
                  }
               }
            }
         }
      }
      &#contact-section {
         background-color: transparent;
         display: flex;
         flex-direction: column;
         justify-content: center;
         align-items: center;

         .main-title {
            color: #d72eda;
            font-size: 54px;
            font-weight: 600;
            margin: 0;
            text-align: center;

            @media (max-width: 1024px) and (min-width: 769px) {
               font-size: 48px;
            }

            @media (max-width: 768px) {
               font-size: 32px;
            }
         }

         .main-subtitle {
            color: #fff;
            font-size: 44px;
            font-weight: 200;
            margin-top: 2rem;
            text-align: center;
            line-height: 1.4;

            @media (max-width: 1024px) and (min-width: 769px) {
               font-size: 36px;
            }

            @media (max-width: 768px) {
               font-size: 24px;
               margin-top: 1rem;
            }
         }

         .contact-title {
            color: #fff;
            font-size: 42px;
            font-weight: 500;
            margin: 0;
            margin-top: 6rem;
            text-align: center;

            @media (max-width: 1024px) and (min-width: 769px) {
               font-size: 36px;
               margin-top: 5rem;
            }

            @media (max-width: 768px) {
               font-size: 28px;
               margin-top: 4rem;
            }
         }

         .contact-subtitle {
            color: #a6a6a6;
            text-align: center;
            font-size: 24px;
            font-weight: 300;
            margin-top: 1rem;

            @media (max-width: 1024px) and (min-width: 769px) {
               font-size: 20px;
            }

            @media (max-width: 768px) {
               font-size: 18px;
            }
         }

         .contact-card {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 2.5rem;
            background-color: #0000002e;
            margin-top: 2rem;
            padding: 2.5rem 3rem;
            border-radius: 1rem;
            width: fit-content;

            @media (max-width: 1024px) and (min-width: 769px) {
               padding: 2rem 2.5rem;
               gap: 2rem;
            }

            @media (max-width: 768px) {
               flex-direction: column;
               padding: 2rem 1.5rem;
               gap: 1.5rem;
               width: 90%;
            }

            .contact-image {
               width: 220px;
               height: 220px;
               border-radius: 50%;
               overflow: hidden;
               border: 3px solid #00000060;
               // box-shadow: 0 0 20px rgba(4, 178, 231, 0.5), 0 0 40px rgba(4, 178, 231, 0.3);

               @media (max-width: 1024px) and (min-width: 769px) {
                  width: 180px;
                  height: 180px;
               }

               @media (max-width: 768px) {
                  width: 150px;
                  height: 150px;
               }

               img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
               }
            }

            .contact-info {
               display: flex;
               flex-direction: column;
               align-items: flex-start;
               gap: 0.5rem;

               @media (max-width: 768px) {
                  align-items: center;
               }

               h3 {
                  color: #fff;
                  margin: 0;
                  font-size: 38px;
                  font-weight: 600;

                  @media (max-width: 1024px) and (min-width: 769px) {
                     font-size: 32px;
                  }

                  @media (max-width: 768px) {
                     font-size: 28px;
                  }
               }

               a {
                  color: #a6a6a6;
                  text-decoration: none;
                  font-size: 26px;
                  font-weight: 300;
                  transition: all 0.3s ease;
                  position: relative;

                  @media (max-width: 1024px) and (min-width: 769px) {
                     font-size: 22px;
                  }

                  @media (max-width: 768px) {
                     font-size: 18px;
                  }

                  &::after {
                     content: "";
                     position: absolute;
                     bottom: -4px;
                     left: 0;
                     width: 0;
                     height: 2px;
                     background: linear-gradient(135deg, #d72eda, #04a7e7);
                     transition: width 0.3s ease;
                  }

                  &:hover {
                     color: #fb3cd4;

                     &::after {
                        width: 100%;
                     }
                  }
               }
            }
         }
      }

      &#content-three {
         background-color: transparent;
      }

      h1,
      h2,
      p {
         margin: 0;
      }

      h1 {
         font-size: 40px;
         font-weight: 400;
         line-height: 1.2;
      }

      h2 {
         font-size: 64px;
         font-weight: 600;
         line-height: 1.4;
      }
      h3 {
         font-size: 52px;
         font-weight: 200;
         line-height: 1.4;
      }

      p {
         font-size: 18px;
         font-weight: 100;
         line-height: 36px;
         letter-spacing: 1px;
         max-width: 760px;
      }

      strong {
         font-weight: 500;
      }

      .feature-boxes {
         list-style: none;
         padding: 0;
         margin: 0;

         li {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 1rem;
            background-color: rgba(0, 0, 0, 0.25);
            padding: 2rem 1.5rem;
            border-radius: 12px;
            font-size: 18px;
            font-weight: 400;
            line-height: 1.6;
            color: #fff;
            text-align: center;

            svg {
               filter: drop-shadow(0 0 10px rgba(215, 46, 218, 0.6)) drop-shadow(0 0 20px rgba(215, 46, 218, 0.4));
            }
         }
      }

      // Section-specific colors
      &#content-one {
         h1 {
            color: #fb3cd4;
         }
         h2 {
            color: #fff;
         }
         p {
            color: #e6e6e6;
         }
      }

      &#content-two {
         h1,
         h2,
         p {
            color: #0f0f1a;
         }

         .raffle-container {
            display: flex;
            align-items: center;
            gap: 1rem;
            width: fit-content;
            padding: 1rem 1rem;
            padding-right: 2rem;
            border-radius: 1rem;
            background: #11111b;
            background-color: #0000004a;
            cursor: pointer;
            border: 2px solid #11111b;

            @media (max-width: 768px) {
               flex-direction: column;
               width: 100%;
               padding: 1.5rem 1rem;
               text-align: center;
            }

            .raffle-text,
            .raffle-text *,
            .raffle-text strong {
               color: #fff !important;
            }

            &:hover {
               border-color: #d72eda;
               background: #11111b;
            }
         }

         .raffle-text {
            font-size: 28px;
            font-weight: 400;
            line-height: 42px;
            margin: 0;
            max-width: 100%;

            @media (max-width: 768px) {
               font-size: 18px;
               line-height: 28px;
            }

            .raffle-highlight {
               font-size: 28px;
               font-weight: 700;

               @media (max-width: 768px) {
                  font-size: 18px;
               }
               color: #d72eda;
               background: linear-gradient(135deg, #d72eda 0%, #04a7e7 100%);
               -webkit-background-clip: text;
               -webkit-text-fill-color: transparent;
               background-clip: text;
               cursor: pointer;
               transition: all 0.3s ease;

               &:hover {
                  text-decoration-thickness: 3px;
                  transform: scale(1.05);
                  display: inline-block;
               }
            }

            .turkish-airlines {
               font-weight: 600;
            }
         }
      }

      &#slider {
         background-color: transparent;
         display: flex;
         justify-content: flex-start;
         align-items: center;
         padding-top: 8rem;
         padding-bottom: 8rem;
         background: linear-gradient(to bottom, transparent 0%, rgba(0, 0, 0, 0.15) 0%, rgba(0, 0, 0, 0.15) 80%, transparent 100%);

         @media (max-width: 768px) {
            padding-top: 4rem;
            padding-bottom: 4rem;
            overflow: hidden;
            height: 300px;
         }

         h1,
         h2,
         h3,
         p {
            color: #fff;
         }

         .slider-content {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: fit-content;
            transform: scale(1.125);
            transform-origin: top center;

            @media (max-width: 1024px) and (min-width: 769px) {
               transform: scale(0.9);
            }

            @media (max-width: 768px) {
               transform: scale(0.5);
               transform-origin: top center;
               width: 100%;
            }
         }

         .slide {
            width: 900px;
            min-height: 400px;

            position: relative;
            // margin-bottom: 2rem;
            background-image: url("../assets/landingpage/01.png");
            background-repeat: no-repeat;
            background-size: 900px;
            padding-left: 90px;
            background-position-y: 50px;
            will-change: opacity;
            transform: translateZ(0);
            backface-visibility: hidden;
            $glow-color: #04b2e7;

            .slide-up-section {
               display: flex;
               align-items: flex-end;
               min-height: 136px;
               gap: 0.5rem;

               .title {
                  color: #fff;
                  font-size: 54px;
                  font-weight: 600;
                  display: flex;
                  width: fit-content;
                  line-height: 48px;
                  text-shadow: 0 0 6px rgba($glow-color, 0.6), 0 0 14px rgba($glow-color, 0.5), 0 0 32px rgba($glow-color, 0.4);
                  // animation: text-glow-pulse 3s ease-in-out infinite;
                  will-change: text-shadow;
                  transform: translateZ(0);
               }

               svg {
                  filter: drop-shadow(0 0 8px rgba($glow-color, 0.8)) drop-shadow(0 0 20px rgba($glow-color, 0.6)) drop-shadow(0 0 40px rgba($glow-color, 0.4));
                  // animation: glow-pulse 3s ease-in-out infinite;
                  will-change: filter;
                  transform: translateZ(0);
               }
            }

            .sub-title {
               color: #fff;
               font-size: 18px;
               font-weight: 500;
               display: flex;
               padding-top: 130px;
               text-shadow: 0 0 6px rgba($glow-color, 0.4), 0 0 14px rgba($glow-color, 0.3), 0 0 32px rgba($glow-color, 0.2);
               // animation: text-glow-pulse 3s ease-in-out infinite, subtitle-fade-in 0.75s ease-in forwards;
               will-change: text-shadow, opacity;
               transform: translateZ(0);
            }
         }

         .slider-bullets {
            display: flex;
            gap: 1rem;
            justify-content: center;

            .bullet {
               width: 32px;
               height: 32px;
               border-radius: 50%;
               border: 3px solid #04b2e7;
               background-color: transparent;
               cursor: pointer;
               transition: all 0.3s ease;
               padding: 0;
               display: flex;
               align-items: center;
               justify-content: center;
               color: #04b2e7;
               font-size: 14px;
               font-weight: 600;

               @media (max-width: 768px) {
                  width: 40px;
                  height: 40px;
                  font-size: 16px;
                  border-width: 4px;
               }

               &:hover {
                  background-color: rgba(4, 178, 231, 0.5);
                  transform: scale(1.1);
                  color: #fff;
               }

               &.active {
                  background-color: #04b2e7;
                  box-shadow: 0 0 8px rgba(4, 178, 231, 0.8), 0 0 16px rgba(4, 178, 231, 0.6);
                  color: #fff;
               }
            }
         }

         // Fade transition for slides
         .fade-enter-active,
         .fade-leave-active {
            transition: opacity 0.3s ease;
            will-change: opacity;
         }

         .fade-enter-from,
         .fade-leave-to {
            opacity: 0;
         }
      }

      &#content-three {
         h1,
         h2,
         h3,
         p {
            color: #fff;
         }
      }

      // Responsive
      @media (max-width: 768px) {
         padding: 4rem 0rem;

         h1 {
            font-size: 32px;
         }

         h2 {
            font-size: 40px;
         }

         p {
            font-size: 16px;
            line-height: 32px;
         }
      }
   }
}

.scroll-helper {
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;
   position: fixed !important;
   bottom: 2rem;
   left: 0;
   right: 0;
   animation: scrollDown 1s infinite;
   animation-delay: 1s;
   @media (max-height: 680px) {
      right: 1rem;
      left: auto;
   }
}

@keyframes scrollDown {
   0% {
      transform: translateY(0);
   }
   33% {
      transform: translateY(15px);
   }
   35% {
      transform: translateY(0);
   }
   100% {
      transform: translateY(0);
   }
}

@keyframes noise-animation {
   0% {
      transform: translate(0, 0);
   }
   10% {
      transform: translate(-5%, -5%);
   }
   20% {
      transform: translate(-10%, 5%);
   }
   30% {
      transform: translate(5%, -10%);
   }
   40% {
      transform: translate(-5%, 15%);
   }
   50% {
      transform: translate(-10%, 5%);
   }
   60% {
      transform: translate(15%, 0);
   }
   70% {
      transform: translate(0, 10%);
   }
   80% {
      transform: translate(-15%, 0);
   }
   90% {
      transform: translate(10%, 5%);
   }
   100% {
      transform: translate(5%, 0);
   }
}

// Glow pulse animation
@keyframes glow-pulse {
   0%,
   100% {
      filter: drop-shadow(0 0 8px rgba(4, 178, 231, 0.8)) drop-shadow(0 0 20px rgba(4, 178, 231, 0.6)) drop-shadow(0 0 40px rgba(4, 178, 231, 0.4));
   }
   50% {
      filter: drop-shadow(0 0 16px rgba(4, 178, 231, 1)) drop-shadow(0 0 32px rgba(4, 178, 231, 0.9)) drop-shadow(0 0 60px rgba(4, 178, 231, 0.7));
   }
}

@keyframes text-glow-pulse {
   0%,
   100% {
      text-shadow: 0 0 6px rgba(4, 178, 231, 0.6), 0 0 14px rgba(4, 178, 231, 0.5), 0 0 32px rgba(4, 178, 231, 0.4);
   }
   50% {
      text-shadow: 0 0 12px rgba(4, 178, 231, 1), 0 0 24px rgba(4, 178, 231, 0.8), 0 0 48px rgba(4, 178, 231, 0.6);
   }
}

@keyframes subtitle-fade-in {
   0% {
      opacity: 0;
   }
   100% {
      opacity: 1;
   }
}

// Registration Form Styles
#registration-form-wrapper {
   position: fixed;
   z-index: 99999;
   background: #00000050;
   top: 0;
   left: 0;
   bottom: 0;
   right: 0;

   #close-registration-form {
      position: absolute;
      right: 1rem;
      top: 1rem;
      background: #eaeaea;
      width: 32px;
      height: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #4a4a4a;
      font-weight: 500;
      border-radius: 50%;
      cursor: pointer;
      border: 1px solid #b2b2b2;
      transition: all 0.3s ease;

      &:hover {
         background: #d72eda;
         color: #0f0f1a;
         border-color: #d72eda;
      }
   }

   #registration-form-inner-container {
      width: 92vw;
      height: fit-content;
      max-height: 90vh;
      position: relative;
      overflow: hidden;
      overflow-y: auto;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      position: absolute;
      background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f0f1a 100%);
      // background: rgba(0, 0, 0);
      // border: 2px solid rgba(215, 46, 218, 0.3);
      // box-shadow: 0 0 40px rgba(215, 46, 218, 0.2), 0 8px 32px rgba(0, 0, 0, 0.4);
      border-radius: 1rem;
      padding: 2rem 1.5rem;

      .registration-form-overflow {
         width: 100%;

         .form-title {
            font-size: 1.5rem;
            font-weight: 600;
            color: #d72eda;
            margin-bottom: 1rem;
            display: block;
         }

         .form-info {
            font-size: 0.9rem;
            color: #e6e6e6;
            line-height: 1.3rem;
            padding: 0.5rem 0;
            margin-bottom: 1rem;
         }

         .feedback-component {
            display: flex;
            align-items: center;
            padding: 1rem;
            margin: 1rem 0;
            border-radius: 0.5rem;
            position: relative;
            animation: slideDown 0.3s ease-out;

            &.success {
               background-color: rgba(215, 46, 218, 0.1);
               border: 1px solid rgba(215, 46, 218, 0.3);
               color: #d72eda;

               .feedback-icon {
                  background-color: #d72eda;
                  color: #0f0f1a;
               }
            }

            &.error {
               background-color: rgba(220, 53, 69, 0.1);
               border: 1px solid rgba(220, 53, 69, 0.3);
               color: #ff6b6b;

               .feedback-icon {
                  background-color: #dc3545;
                  color: white;
               }
            }

            .feedback-icon {
               width: 32px;
               height: 32px;
               border-radius: 50%;
               display: flex;
               align-items: center;
               justify-content: center;
               font-weight: bold;
               font-size: 1.2rem;
               margin-right: 1rem;
               flex-shrink: 0;
            }

            .feedback-content {
               flex: 1;

               p {
                  margin: 0;
                  font-weight: 500;
               }
            }

            .feedback-close {
               background: none;
               border: none;
               font-size: 1.5rem;
               cursor: pointer;
               padding: 0.25rem;
               line-height: 1;
               opacity: 0.7;
               margin-left: 1rem;
               color: inherit;

               &:hover {
                  opacity: 1;
               }
            }
         }

         @keyframes slideDown {
            from {
               opacity: 0;
               transform: translateY(-20px);
            }
            to {
               opacity: 1;
               transform: translateY(0);
            }
         }

         .form-section {
            display: grid;
            width: 100%;
            grid-template-columns: auto;
            margin: 1rem 0;

            .input-container {
               display: grid;
               grid-template-columns: 200px 1fr;
               gap: 0.75rem;
               align-items: center;
               margin-bottom: 0.75rem;

               @media (max-width: 576px) {
                  grid-template-columns: 1fr;
                  gap: 0.5rem;
               }

               label {
                  font-size: 0.9rem;
                  font-weight: 500;
                  color: #e6e6e6;

                  @media (max-width: 576px) {
                     font-size: 0.8rem;
                     margin-bottom: 0.2rem;
                  }
               }

               input {
                  background-color: rgba(255, 255, 255, 0.05);
                  border: 1px solid rgba(215, 46, 218, 0.2);
                  outline: 0;
                  height: 42px;
                  font-size: 1rem;
                  text-indent: 0.75rem;
                  border-radius: 0.5rem;
                  color: #fff;
                  transition: all 0.3s ease;

                  &:focus {
                     border: 1px solid #d72eda;
                     box-shadow: 0 0 10px rgba(215, 46, 218, 0.2);
                     background-color: rgba(255, 255, 255, 0.08);
                  }

                  &:disabled {
                     background-color: rgba(255, 255, 255, 0.02);
                     color: #999;
                     cursor: not-allowed;
                     opacity: 0.6;
                  }

                  &::placeholder {
                     color: #666;
                  }
               }
            }
         }

         .consent-wrapper {
            display: flex;
            margin: 1.5rem 0;
            border-radius: 0.5rem;
            padding: 0.75rem 1rem;
            align-items: center;
            justify-content: center;
            background-color: rgba(0, 0, 0, 0.2);

            .checkbox {
               width: 20px;
               height: 20px;
               border: 0.125rem solid #d72eda;
               flex-shrink: 0;
               border-radius: 0.25rem;
               cursor: pointer;
               transition: all 0.3s ease;

               &.confirmed {
                  background-color: #d72eda;
                  cursor: pointer;

                  &:after {
                     content: "";
                     background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMC4wODQiIGhlaWdodD0iNy43NyIgdmlld0JveD0iMCAwIDEwLjA4NCA3Ljc3Ij48cGF0aCBkPSJNMTcuNTA4LDI0LjQyNmEuNjgyLjY4MiwwLDAsMS0uMzg3LS4xMmwtMy41NDYtMi40MzNhLjY4NS42ODUsMCwwLDEsLjc3NS0xLjEzbDMuMDIzLDIuMDc1LDQuNzctNS45MDdhLjY4NS42ODUsMCwxLDEsMS4wNjYuODYxbC01LjE2OCw2LjRBLjY4NC42ODQsMCwwLDEsMTcuNTA4LDI0LjQyNloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMy4yNzggLTE2LjY1NykiIGZpbGw9IiMwZjBmMWEiLz48L3N2Zz4=");
                     background-size: 70%;
                     width: 100%;
                     height: 100%;
                     display: block;
                     background-repeat: no-repeat;
                     background-position: center;
                  }
               }

               &:hover {
                  box-shadow: 0 0 10px rgba(215, 46, 218, 0.3);
               }

               &.disabled {
                  opacity: 0.4;
                  cursor: not-allowed;
                  border-color: #666;

                  &.confirmed {
                     background-color: #666;
                  }
               }
            }

            p {
               margin: 0;
               margin-left: 0.75rem;
               padding-left: 0.75rem;
               font-size: 0.9rem;
               line-height: 1.3rem;
               color: #e6e6e6;
               border-left: 1px solid rgba(215, 46, 218, 0.2);
            }
         }

         #registration-form-actions {
            width: 100%;
            display: flex;
            justify-content: center;
            margin: 1.5rem 0;

            button {
               margin: 0 0.5rem;
               min-height: 44px;
               width: fit-content;
               min-width: 200px;
               background: linear-gradient(135deg, #d72eda, #04a7e7);
               border: none;
               color: #0f0f1a;
               font-weight: 600;
               font-size: 1rem;
               padding: 0.75rem 2rem;
               border-radius: 0.5rem;
               cursor: pointer;
               transition: all 0.3s ease;

               &:hover:not(:disabled) {
                  transform: translateY(-2px);
                  box-shadow: 0 0 20px rgba(215, 46, 218, 0.5);
               }

               &:disabled {
                  opacity: 0.5;
                  cursor: not-allowed;
                  transform: none;
               }

               .loader {
                  width: 24px;
                  height: 24px;
                  border: 3px solid #0f0f1a;
                  border-bottom-color: transparent;
                  border-radius: 50%;
                  display: inline-block;
                  box-sizing: border-box;
                  animation: rotation 1s linear infinite;
               }

               @keyframes rotation {
                  0% {
                     transform: rotate(0deg);
                  }
                  100% {
                     transform: rotate(360deg);
                  }
               }
            }
         }

         .upload-section {
            margin-top: 2rem;
            padding-top: 1.5rem;
            border-top: 1px solid rgba(215, 46, 218, 0.2);

            h3 {
               margin-bottom: 0.75rem;
               color: #d72eda;
               font-size: 1.1rem;
               font-weight: 500;
            }

            .file-requirement-warning {
               display: flex;
               align-items: flex-start;
               padding: 1rem;
               margin: 1rem 0;
               border-radius: 0.5rem;
               border: 1px solid;

               &.warning {
                  background-color: rgba(255, 193, 7, 0.1);
                  border-color: rgba(255, 193, 7, 0.3);
                  color: #ffc107;

                  .warning-icon {
                     background-color: #ffc107;
                     color: #0f0f1a;
                  }
               }

               &.success {
                  background-color: rgba(215, 46, 218, 0.1);
                  border-color: rgba(215, 46, 218, 0.3);
                  color: #d72eda;

                  .warning-icon {
                     background-color: #d72eda;
                     color: #0f0f1a;
                  }
               }

               .warning-icon {
                  width: 28px;
                  height: 28px;
                  border-radius: 50%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-weight: bold;
                  font-size: 1rem;
                  margin-right: 0.75rem;
                  flex-shrink: 0;
               }

               .warning-content {
                  flex: 1;

                  p {
                     margin: 0;
                     font-weight: 500;
                     font-size: 0.9rem;
                     line-height: 1.4;
                  }

                  .form-warning-informations-wrapper {
                     list-style: none;
                     padding: 0;
                     margin: 0;

                     .form-warning-informations-item {
                        display: flex;
                        flex-direction: column;
                        margin-bottom: 0.75rem;

                        &:last-child {
                           margin-bottom: 0;
                        }

                        .form-warning-informations-item-title {
                           font-weight: 600;
                           margin-bottom: 0.25rem;
                        }

                        .form-warning-informations-item-description {
                           font-weight: 400;
                           opacity: 0.9;
                           font-size: 0.85rem;
                        }
                     }
                  }
               }
            }
         }

         .upload-area {
            border: 2px dashed rgba(215, 46, 218, 0.3);
            border-radius: 0.5rem;
            padding: 2rem;
            text-align: center;
            margin-bottom: 1rem;
            cursor: pointer;
            background-color: rgba(0, 0, 0, 0.2);
            transition: all 0.3s ease;

            &:hover {
               border-color: #d72eda;
               background-color: rgba(215, 46, 218, 0.05);
            }

            .upload-content {
               p {
                  margin: 0;
                  color: #e6e6e6;
                  font-size: 0.95rem;
               }
            }
         }

         .uploaded-files {
            margin-top: 1rem;
         }

         .file-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0.5rem 0.75rem;
            background: rgba(215, 46, 218, 0.1);
            border: 1px solid rgba(215, 46, 218, 0.2);
            border-radius: 0.4rem;
            margin-bottom: 0.5rem;
            font-size: 0.9rem;
            color: #e6e6e6;

            button {
               background: #dc3545;
               color: white;
               border: none;
               border-radius: 50%;
               width: 24px;
               height: 24px;
               cursor: pointer;
               font-size: 16px;
               line-height: 1;
               display: flex;
               align-items: center;
               justify-content: center;
               padding: 0;
               flex-shrink: 0;
               transition: all 0.3s ease;

               &:hover {
                  background: #c82333;
                  transform: scale(1.1);
               }
            }
         }
      }
   }

   @media (min-width: 1200px) {
      #registration-form-inner-container {
         width: 70vw;
      }
   }

   @media (min-width: 1600px) {
      #registration-form-inner-container {
         width: 50vw;
         max-width: 900px;
      }
   }
}
</style>
